export default __webpack_public_path__ + "static/media/consierge-greet-avatar.609691c8.png";